import {useEffect, useState} from 'react';

const imaScriptId = 'ima-sdk';

const initImaScript = onLoad => {
  if (!document.getElementById(imaScriptId)) {
    const script = document.createElement('script');
    script.src = '//imasdk.googleapis.com/js/sdkloader/ima3.js';
    script.async = true;
    script.type = 'text/javascript';
    script.id = imaScriptId;
    script.onload = () => onLoad();
    document.body.appendChild(script);
  } else {
    // Script already appended
    onLoad();
  }
};

export const useInitImaScript = () => {
  const [imaScriptLoaded, setImaScriptLoaded] = useState(false);

  useEffect(() => {
    initImaScript(() => setImaScriptLoaded(true));
    return () => {
      const script = document.getElementById(imaScriptId);
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return imaScriptLoaded;
};
